import React, { useState } from "react";
import axiosInstance from "../../variables/api/axiosInstance";
import SideBar from "../../components/SideBar";
import NavBar from "../../components/NavBar";
import Footer from "../../components/Footer";

const BulkEmailSender = () => {
    const [formData, setFormData] = useState({
        senderEmail: "",
        senderPassword: "",
        subject: "",
        title: "",
        paragraphs: [""],
        buttonText: "",
        buttonUrl: "",
        targetProfile: "ALL",
        ccEmails: "",
        specificEmails: "",
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleParagraphChange = (index, value) => {
        const newParagraphs = [...formData.paragraphs];
        newParagraphs[index] = value;
        setFormData({ ...formData, paragraphs: newParagraphs });
    };

    const addParagraph = () => {
        setFormData({ ...formData, paragraphs: [...formData.paragraphs, ""] });
    };

    const removeParagraph = (index) => {
        const newParagraphs = formData.paragraphs.filter((_, i) => i !== index);
        setFormData({ ...formData, paragraphs: newParagraphs });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ type: "", text: "" });

        try {
            const payload = {
                senderEmail: formData.senderEmail,
                senderPassword: formData.senderPassword,
                subject: formData.subject,
                title: formData.title,
                paragraphs: formData.paragraphs.filter((p) => p.trim() !== ""),
                buttonText: formData.buttonText || null,
                buttonUrl: formData.buttonUrl || null,
                targetProfile: formData.targetProfile,
                ccEmails: formData.ccEmails
                    ? formData.ccEmails.split(",").map((e) => e.trim())
                    : [],
                specificEmails: formData.specificEmails
                    ? formData.specificEmails.split(",").map((e) => e.trim())
                    : null,
            };

            const response = await axiosInstance.post("/api/mail/send-bulk", payload);

            setMessage({
                type: "success",
                text: response.data.message || "Emails envoyés avec succès!",
            });

            // Reset form
            setFormData({
                senderEmail: "",
                senderPassword: "",
                subject: "",
                title: "",
                paragraphs: [""],
                buttonText: "",
                buttonUrl: "",
                targetProfile: "ALL",
                ccEmails: "",
                specificEmails: "",
            });
        } catch (error) {
            setMessage({
                type: "error",
                text:
                    error.response?.data?.message ||
                    "Erreur lors de l'envoi des emails",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar />

                <div className="layout-page">
                    <NavBar />

                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <h4 className="fw-bold py-3 mb-4">
                                <span className="text-muted fw-light">Emails /</span> Envoi
                                groupé
                            </h4>

                            {message.text && (
                                <div
                                    className={`alert alert-${message.type === "success" ? "success" : "danger"
                                        } alert-dismissible`}
                                    role="alert"
                                >
                                    {message.text}
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setMessage({ type: "", text: "" })}
                                    ></button>
                                </div>
                            )}

                            <div className="card">
                                <div className="card-header d-flex align-items-center justify-content-between">
                                    <h5 className="mb-0">Envoyer un email groupé</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        {/* Sender Credentials */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label className="form-label" htmlFor="senderEmail">
                                                    Email expéditeur *
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="senderEmail"
                                                    name="senderEmail"
                                                    value={formData.senderEmail}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="votre.email@exemple.com"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label
                                                    className="form-label"
                                                    htmlFor="senderPassword"
                                                >
                                                    Mot de passe SMTP *
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    id="senderPassword"
                                                    name="senderPassword"
                                                    value={formData.senderPassword}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="Votre mot de passe SMTP"
                                                />
                                            </div>
                                        </div>

                                        {/* Email Content */}
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="subject">
                                                Objet *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="subject"
                                                name="subject"
                                                value={formData.subject}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="Objet de l'email"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="title">
                                                Titre *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="title"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="Titre principal de l'email"
                                            />
                                        </div>

                                        {/* Paragraphs */}
                                        <div className="mb-3">
                                            <label className="form-label">Paragraphes *</label>
                                            {formData.paragraphs.map((paragraph, index) => (
                                                <div key={index} className="input-group mb-2">
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        value={paragraph}
                                                        onChange={(e) =>
                                                            handleParagraphChange(index, e.target.value)
                                                        }
                                                        placeholder={`Paragraphe ${index + 1}`}
                                                        required
                                                    ></textarea>
                                                    {formData.paragraphs.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger"
                                                            onClick={() => removeParagraph(index)}
                                                        >
                                                            <i className="bx bx-trash"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={addParagraph}
                                            >
                                                <i className="bx bx-plus"></i> Ajouter un paragraphe
                                            </button>
                                        </div>

                                        {/* Optional Button */}
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label className="form-label" htmlFor="buttonText">
                                                    Texte du bouton (optionnel)
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="buttonText"
                                                    name="buttonText"
                                                    value={formData.buttonText}
                                                    onChange={handleInputChange}
                                                    placeholder="Accéder à la plateforme"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label" htmlFor="buttonUrl">
                                                    URL du bouton (optionnel)
                                                </label>
                                                <input
                                                    type="url"
                                                    className="form-control"
                                                    id="buttonUrl"
                                                    name="buttonUrl"
                                                    value={formData.buttonUrl}
                                                    onChange={handleInputChange}
                                                    placeholder="https://preprod.poolinsapp.oapps.net"
                                                />
                                            </div>
                                        </div>

                                        {/* Recipients */}
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="targetProfile">
                                                Profil destinataire
                                            </label>
                                            <select
                                                className="form-select"
                                                id="targetProfile"
                                                name="targetProfile"
                                                value={formData.targetProfile}
                                                onChange={handleInputChange}
                                            >
                                                <option value="ALL">Tous les utilisateurs</option>
                                                <option value="ADMIN">Administrateurs</option>
                                                <option value="USER">Utilisateurs</option>
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="specificEmails">
                                                Emails spécifiques (optionnel, séparés par des
                                                virgules)
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="specificEmails"
                                                name="specificEmails"
                                                value={formData.specificEmails}
                                                onChange={handleInputChange}
                                                placeholder="user1@example.com, user2@example.com"
                                            />
                                            <small className="text-muted">
                                                Si rempli, remplace le profil sélectionné
                                            </small>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="ccEmails">
                                                Emails en copie (optionnel, séparés par des virgules)
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="ccEmails"
                                                name="ccEmails"
                                                value={formData.ccEmails}
                                                onChange={handleInputChange}
                                                placeholder="manager@example.com, support@example.com"
                                            />
                                        </div>

                                        <div className="mt-4">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Envoi en cours...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bx bx-send me-2"></i>
                                                        Envoyer les emails
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* Example Preview */}
                            <div className="card mt-4">
                                <div className="card-header">
                                    <h5 className="mb-0">Exemple d'utilisation</h5>
                                </div>
                                <div className="card-body">
                                    <h6>
                                        Pour annoncer le changement de lien de la plateforme :
                                    </h6>
                                    <ul>
                                        <li>
                                            <strong>Objet:</strong> Changement d'adresse de la
                                            plateforme PoolIns
                                        </li>
                                        <li>
                                            <strong>Titre:</strong> Nouvelle adresse de la plateforme
                                        </li>
                                        <li>
                                            <strong>Paragraphe 1:</strong> Nous vous informons que
                                            l'adresse de la plateforme PoolIns a changé.
                                        </li>
                                        <li>
                                            <strong>Paragraphe 2:</strong> L'ancienne adresse{" "}
                                            <strong>poolinsapptest.oapps.net</strong> sera remplacée
                                            par <strong>preprod.poolinsapp.oapps.net</strong>
                                        </li>
                                        <li>
                                            <strong>Paragraphe 3:</strong> Merci de mettre à jour vos
                                            favoris.
                                        </li>
                                        <li>
                                            <strong>Texte du bouton:</strong> Accéder à la nouvelle
                                            plateforme
                                        </li>
                                        <li>
                                            <strong>URL du bouton:</strong>{" "}
                                            https://preprod.poolinsapp.oapps.net
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <Footer />

                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>

            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>
    );
};

export default BulkEmailSender;